import { cn } from "@/lib/utils";

export const StatusBadge = ({ status = "In Development", className = "", testid }) => (
  <span
    data-testid={testid}
    className={cn(
      "inline-flex items-center gap-1.5 rounded-full bg-purple px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-cream",
      className
    )}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-sunny" />
    {status}
  </span>
);

export const Eyebrow = ({ children, className = "", color = "text-marigold" }) => (
  <span className={cn("text-xs font-bold uppercase tracking-[0.22em]", color, className)}>
    {children}
  </span>
);

export const Section = ({ children, className = "", id, ...props }) => (
  <section id={id} className={cn("px-5 md:px-8", className)} {...props}>
    <div className="mx-auto max-w-7xl">{children}</div>
  </section>
);
